import Master from 'components/helper/Master'
import React from 'react'
import NewDegree from 'NewDegree';
function DegreeMaster() {
  return (
   <NewDegree/>
  )
}

export default DegreeMaster;